import React, { useState,useEffect } from "react";
import StepButtons from "../components/StepButtons";
import Swal from "sweetalert2";
import FormButtons from "../components/FormButtons";
import AddMore from "../components/AddMore";
import FormTitle from "../components/FormTitle";
import { postToServer, uploadDocs } from "../apis";
import "jquery-validation";
import $ from "jquery";
import GoToReviewPageButton from "../components/GoToReviewPageButton";

const FormList = ({
  list,
  setList,
  data,
  setData,
  emptyObj,
  backPage,
  nextPage,
  FormComp,
  PanelComp,
  formTitle,
  addGuideLines,
  pageName,
  server_url,
  callLicenseDetailApi,
  alert = undefined,
  setAlert = undefined,
  credentials,
  specificPage = undefined,
  violations = undefined,
  emptyViolationObj = undefined,
  lastinsertmvrdataid = undefined,
  isDone,
  lastPage,
  mvrLoadeding = undefined,
  lastMvrReq = undefined,
  pageNo,
}) => {

  
  // ---------- states variables ----------
  const [isAdding, setIsAdding] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  
  // Use credentials values or fallback to local storage
  const duid = credentials.duid || localStorage.getItem('duid');
  const parentId = credentials.parent_id || localStorage.getItem('parent_id');

  // Create a new object with the updated credentials
  const updatedCredentials = {
    duid: duid,
    parent_id: parentId,
  };

  // ---------- functions ----------
  
  const saveData = () => {
    const form = $("#data-form");
    form.validate();
  
    if (form.valid()) {
      let savedData;
  
      if (editIndex === null) {
        // Adding a new entry
        setList([...list, data]);
        savedData = data;
      } else {
        // Updating an existing entry
        list[editIndex] = data;
        setEditIndex(null);
        setList([...list]);
        savedData = data;
      }
  
      if (list.length === 0 && pageNo === 15) {
        list[0] = data;
        setList([...list]);
        savedData = data;
      }
  
      setIsAdding(false);
      setData(emptyObj);
  
      // Save data into local storage with respect to pageNo
      const storedData = localStorage.getItem(`form_${pageNo}`);
      const newData = storedData ? JSON.parse(storedData) : [];
  
      if (editIndex === null) {
        // Adding a new entry to local storage
        newData.push(savedData);
      } else {
        // Updating an existing entry in local storage
        newData[editIndex] = savedData;
      }
  
      localStorage.setItem(`form_${pageNo}`, JSON.stringify(newData));
      return savedData;
    }
  
    return false;
  };
  
/////////////
useEffect(() => {
  try {
    // Check if pageNo is defined before setting the storage key
    const storageKey = `form_${pageNo || ''}`;
    const storedData = localStorage.getItem(storageKey);
  //console.log(`Retrieving data for ${storageKey}:`, storedData);

    if (pageNo === 15) {
    
      if (storedData && storedData.length > 0) {
        setEditIndex(0);
        setData(JSON.parse(storedData)[0]);
        setIsAdding(true);
      }
    } else {
      
      if (storedData) {
        setList(JSON.parse(storedData));

        // If the page number is 16 and data is available, set the form data
        if (pageNo === 16 && storedData.length > 0) {
          setEditIndex(0);
          setData(JSON.parse(storedData)[0]);
          setIsAdding(true);
        }
      }
    }
  } catch (error) {
    console.error("Error:", error);
  }
},  [pageNo, setList]);

//////////
  const cancelData = () => {
    setData(emptyObj);
    setIsAdding(false);
    setEditIndex(null);
  };
  const eventHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const editData = (index) => {
    setEditIndex(index);
    setData(list[index]);
    setIsAdding(true);
  };
  
  const deleteData = (index) => {
    Swal.fire({
      title: "Do you really want to delete this " + pageName + "?",
      icon: "warning",
      showCancelButton: true,
      buttons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        // Remove item from local storage
        try {
          const storedList = localStorage.getItem(`form_${pageNo}`);
          if (storedList) {
            const parsedList = JSON.parse(storedList);
            parsedList.splice(index, 1);
            localStorage.setItem(`form_${pageNo}`, JSON.stringify(parsedList));
          }
        } catch (error) {
          console.error("Error removing item from local storage:", error);
        }
  
        // Update state
        if (editIndex !== null) {
          setEditIndex(null);
          setData(emptyObj);
        }
        list.splice(index, 1);
        setList([...list]);
      }
    });
  };
  const goNext = async (goLast) => {
	let dataSend = {}
	if(pageNo === 15 || pageNo === 16){
		  if(!editIndex && $("#data-form").length > 0){
			let saved =  saveData();
			if(!saved){
				return false;
			}
			//dataSend = saved;
		  }
	}
    // ---------- code for sending data on server ----------
    const reqData = { ...updatedCredentials, data: dataSend };
    if (specificPage == "violations") {
      reqData.lastinsertmvrdataid = lastinsertmvrdataid;
    }
    if (specificPage == "accidents") {
      reqData.data = { violations: {}, accidents: {} };
      for (const key in emptyViolationObj) {
        if (emptyViolationObj.hasOwnProperty(key)) {
          reqData.data.violations[key] = [];
        }
      }
      for (const key in emptyObj) {
        if (emptyObj.hasOwnProperty(key)) {
          reqData.data.accidents[key] = [];
        }
      }
      violations.forEach((element) => {
        for (const key in element) {
          if (element.hasOwnProperty(key)) {
            reqData.data.violations[key].push(element[key]);
          }
        }
      });
      list.forEach((element) => {
        for (const key in element) {
          if (element.hasOwnProperty(key)) {
            reqData.data.accidents[key].push(element[key]);
          }
        }
      });
    } else {
      for (const key in emptyObj) {
        if (emptyObj.hasOwnProperty(key)) {
          reqData.data[key] = [];
        }
      }
      list.forEach((element) => {
        for (const key in element) {
          if (element.hasOwnProperty(key)) {
            // console.log(key + " -> " + element[key]);
            reqData.data[key].push(element[key]);
          }
        }
      });
    }
    // console.log(JSON.stringify(reqData));
    if (server_url) {
      const result = await postToServer(server_url, reqData);
      if (result.status) {
        goLast ? lastPage() : nextPage();
      }
      // else console.log("==> got error while posteding data");
    }
    // ---------- ***************************** ----------
    if (setAlert) setAlert({ type: "info", msg: "", status: false });
  };
  const goBack = () => {
    if (setAlert) setAlert({ type: "info", msg: "", status: false });
    backPage();
  };
let listLength = 3;
let noright = false;
if(pageNo === 15 || pageNo === 16){
	listLength = 1;
	noright = true;
	if(!isAdding && list.length == 0){
		setIsAdding(true);
	}
	if(list.length == 1 && editIndex === null){
		setEditIndex(0);
		setData(list[0]);
		setIsAdding(true);
	}
}
if(pageNo === 16){
	//isDone = true;
}
 // Fetch data from local storage when the component mounts
 useEffect(() => {
  const storedData = localStorage.getItem(`page_data_${pageNo}`);
  if (storedData) {
    const parsedData = JSON.parse(storedData);
    setList(parsedData);
  }
}, [pageNo, setList]);
  // ---------- rendering UI ----------
  return (
    <>
      <div className="general-content licence">
        <div className="row d-flex">
          <div className={noright ? ('col-md-12'):('col-md-9')}>
            <div className="driver-form-container">
              <FormTitle
                title={formTitle}
                alert={alert}
                specificPage={specificPage}
              />
              <div className="container container-collapsed">
                {isAdding ? (
                  <form id="data-form">
                    <FormComp
                      data={data}
                      setData={setData}
                      eventHandler={eventHandler}
                      count={list.length}
                      editIndex={editIndex}
					  pageNo={pageNo}
                    />
                  </form>
                ) : (
                  <AddMore
                    addAllowed={
                      specificPage === "violations" ||
                      specificPage === "accidents" ||
                      specificPage === "experiences" ||
                      specificPage === "employment_histories" ||
                      list.length < listLength
                    }
                    setIsAdding={setIsAdding}
                    pageName={pageName}
                    addGuideLines={addGuideLines}
                    count={list.length}
                  />
                )}
              </div>
			  {noright ? ("") : ( 
			  <FormButtons
					cancelData={cancelData}
					saveData={saveData}
					isAdding={isAdding}
				  />
              
            )}
            </div>
            {/* Footer for Driver Info Tab only */}
            {mvrLoadeding ? (
              ""
            ) : (
              <StepButtons
                goBack={goBack}
                goNext={goNext}
                nextAllowed={
                  list.length > 0 ||
                  (specificPage &&
                    (specificPage === "violations" ||
                      specificPage === "accidents"))
                }
                // nextAllowed={true}
                isAdding={isAdding}
              />
            )}
			{noright ? (
              <StepButtons
                goBack={goBack}
                goNext={goNext}
                nextAllowed={true}
                isAdding={false}
              />
            ) : ( ""
              
            )}
			<GoToReviewPageButton update={lastPage} isDone={isDone} />
          </div>
          <div className={noright ? ('hidden'):('col-md-3 pl-md-0')}>
            <div className="licence-panel">
              <div className="title">{pageName}(s)</div>
              <PanelComp
                list={list}
                editData={editData}
                cancelData={cancelData}
                deleteData={deleteData}
                callLicenseDetailApi={callLicenseDetailApi}
                lastMvrReq={lastMvrReq}
              />
            </div>
          </div>
        </div>
      </div>
      {specificPage === "violations"  ? (
        ""
      ) : (
        <GoToReviewPageButton update={goNext} isDone={isDone} />
      )}
	   </>
  );
};

export default FormList;
